import { capitalize } from "@/lib/utils";

// Prettify d'affichage des canaux d'acquisition connus. Pour toute valeur
// inconnue on reste FIDÈLE : on renvoie la valeur telle quelle si elle contient
// déjà une mise en forme (point/majuscule), sinon on capitalise.
const ACQUISITION_LABELS: Record<string, string> = {
  google: "Google",
  linkedin: "LinkedIn",
  facebook: "Facebook",
  instagram: "Instagram",
  instantly: "Instantly",
  telephone: "Téléphone",
  direct: "Direct",
  referral: "Referral",
  seo: "SEO",
};

export function acquisitionLabel(value?: string | null): string {
  if (value == null || value.trim() === "") return "—";
  const v = value.trim();
  const known = ACQUISITION_LABELS[v.toLowerCase()];
  if (known) return known;
  if (v.includes(".") || /[A-Z]/.test(v)) return v; // domaine / déjà formaté
  return capitalize(v);
}
